import React from "react";
import { Container } from "reactstrap";

import "./Styles.scss";
import APP_CONFIG from "../../APP_CONFIG";

const AuthWrapper = ({ className = "", children }) => {
    return (
        <div
            className={`${className} d-flex align-items-center justify-center min-vh-100 min-vw-100 auth-wrap`}
        >
            <Container className="auth-wrap-right-content w-full py-4">
                <div className="w-100 d-flex align-items-center justify-content-center mt-2">
                    <div
                        style={{
                            background: `url(${APP_CONFIG.IMAGES.LOGIN_RIGHT_IMAGE}) no-repeat center/contain`,
                            height: "40px",
                            width: "150px" // Adjust the height as needed
                        }}
                    ></div>
                </div>
                <div className="auth-child-container">{children}</div>
            </Container>
        </div>
    );
};

export default AuthWrapper;
